import script from "./RestPassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./RestPassword.vue?vue&type=script&lang=ts&setup=true"

import "./RestPassword.vue?vue&type=style&index=0&id=683aadce&scoped=true&lang=css"

import exportComponent from "/Users/carl/project/meta/landings/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-683aadce"]])

export default __exports__